export default __webpack_public_path__ + "static/media/default_gray@1x.1de14a6d.webp";